<template>
  <div class="curl-status modal-container">
    <div class="modal-wrapper">
      <div class="modal-content">
        <carousel
          ref="curl-carousel"
          :navigation-enabled="slider.activeNavigation"
          :per-page="slider.perPage"
          :mouse-drag="false"
          :pagination-enabled="slider.activeNavigation"
          :pagination-active-color="slider.active"
          :navigation-next-label="getArrowImage('/images/right-arrow.svg')"
          :navigation-prev-label="getArrowImage('/images/left-arrow.svg')"
          style="height: 100%; width: 100%;"
          @pageChange="onPageChange"
        >
          <slide class="modal-slider">
            <StatusType
              @type="setType"
            />
          </slide>
          <slide class="modal-slider">
            <Rate @rate="setRate"/>
          </slide>
          <slide
            v-if="formData.type === 'General'"
            class="general-modal">
            <General @curlData="submitCurlForm"/>
          </slide>
          <slide
            v-else
            class="length-modal">
            <LengthCheck @curlData="submitCurlForm"/>
          </slide>
        </carousel>
        <span
          class="close-modal"
          @click.prevent="showModal(false)">+</span>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import VueCarousel from "vue-carousel";
Vue.use(VueCarousel);


import {Carousel, Slide} from 'vue-carousel';
import {mapGetters, mapActions} from "vuex";
import profileMixin from "@/mixins/profileMixin";
import StatusType from "./steps/StatusType";
import Rate from "./steps/Rate";
import General from "./steps/General";
import LengthCheck from "./steps/LengthCheck";

export default {
  components: { StatusType, Carousel, Slide, Rate, General, LengthCheck },
  mixins: [profileMixin],

  data() {
    return {
      formData: {
        type: '',
        curl: [],
        rate: ''
      },
      slider: {
        perPage: 1,
        active: '#603975',
        currentSlide: 1,
        activeNavigation: true,
        paddingCss: '113px 65px 103px 65px'
      },
    }
  },
  mounted() {
    this.currentSlide = this.$refs['curl-carousel'];
  },
  methods: {
    ...mapActions(['saveCurlStatus', 'fetchCurls']),
    submitCurlForm(item) {
        this.formData.curl = item;
        this.saveCurlStatus(this.formData).then(() => {
          this.fetchCurls();
          this.showModal(false);
        });
    },
    setType(item) {
      if (item !== '') {
        this.formData.type = item;
        const curlCarousel = this.$refs['curl-carousel'];
        curlCarousel.goToPage(1)
      } else {
        curlCarousel.goToPage(0)
      }
    },
    setRate(item) {
      this.formData.rate = item;
      const curlCarousel = this.$refs['curl-carousel'];
    },
    getArrowImage(url) {
      return `<img src="${this.getImageUrl(url)}"/>`;
    },
    onPageChange(currentPage) {
      if (currentPage === 1 && this.formData.type !== '' || currentPage === 2 && this.formData.rate) {
        this.slider.currentSlide = currentPage;
      } else {
        this.$refs['curl-carousel'].goToPage(currentPage - 1);
        this.slider.currentSlide = currentPage - 1;
      }
      this.slider.activeNavigation = this.slider.currentSlide <= 2;
    }
  },
}
</script>

<style lang="scss">
.VueCarousel-navigation-next{
  transform: translateY(-50%) translateX(-100%) !important;
}
.VueCarousel-navigation-prev {
  transform: translateY(-50%) translateX(100%) !important;
}
.VueCarousel-dot-container {
   margin-top: 126px !important;
}
.modal-padding {
  padding: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/modals/AddCurlStatus/CurlStatus.vue